import { ApiRoutes } from 'types';
import { axiosInstance } from './axiosInstance';
import { getApiUrl } from './helpers';
import { generatePath } from 'react-router-dom';
import { Feedback } from '../types/Feedback';

export async function createFeedback(body: Feedback) {
  const { data } = await axiosInstance.post<Feedback>(getApiUrl({ path: generatePath(ApiRoutes.Feedback) }), body);
  return data;
}
